import { render } from "./addStockCheck.vue?vue&type=template&id=9b25fbfa&scoped=true"
import script from "./addStockCheck.vue?vue&type=script&lang=js"
export * from "./addStockCheck.vue?vue&type=script&lang=js"

import "./addStockCheck.vue?vue&type=style&index=0&id=9b25fbfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b25fbfa"

export default script